<div class="dialog-wrapper">
    <p>{{ data.message }}</p>
    <button pButton type="button" (click)="ref.close()" label="OK"></button>
  </div>
  